import { Children, FC, PropsWithChildren } from "react";
import { QueryClient, QueryClientProvider } from "react-query";

import { isEditing } from "@builder.io/sdk-react";

import { ProductCardContainer as UIProductCardContainer } from "@jti/ui/components/ProductCardContainer/ProductCardContainer";

import { Placeholder } from "../Placeholder/Placeholder";

import { productCardContainerInputs } from "./ProductCardContainer.builder";

type ProductCardContainerProps = BuilderComponentProps<
  typeof productCardContainerInputs
>;

const client = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

export const ProductCardContainer: FC<
  PropsWithChildren<ProductCardContainerProps>
> = ({
  children,
  isCarousel,
  isControlHidden,
  isOverflowEnabled,
  desktopItemCount,
  tabletItemCount,
  title,
  ctaLabel,
  ctaHref,
}) => {
  const hasChildren = Children.count(children) > 0;
  if (!hasChildren && isEditing()) {
    return (
      <Placeholder>
        Specify Product Card SKU in the Builder.io editor
      </Placeholder>
    );
  }
  return (
    <QueryClientProvider client={client}>
      <UIProductCardContainer
        isCarousel={isCarousel}
        isControlHidden={isControlHidden}
        isOverflowEnabled={isOverflowEnabled}
        desktopItemCount={desktopItemCount}
        tabletItemCount={tabletItemCount}
        title={title}
        ctaLabel={ctaLabel}
        ctaHref={ctaHref}
      >
        {children}
      </UIProductCardContainer>
    </QueryClientProvider>
  );
};
